module.exports = __webpack_public_path__ + "static/blanclabs-logo-9f539373c25ac651ec80200db1585bf1.png";